import http from "@/services/http";

// Central de pedidos (pedidos feitos pela vitrine)
export const orders = () => {
  async function list(status = null) {
    const {data} = await http.get('/orders/list', { params: status ? { status } : {} });
    return data;
  }

  async function getOne(id) {
    const {data} = await http.get('/orders/getOne/'+id);
    return data;
  }

  async function update(order) {
    const response = await http.post('/orders/edit', order);
    return response.data;
  }

  async function updateStatus(id, status) {
    const response = await http.post('/orders/updateStatus/'+id, { status });
    return response.data;
  }

  // id_price_table null = voltar aos preços da vitrine
  async function applyPriceTable(id, id_price_table) {
    const response = await http.post('/orders/applyPriceTable/'+id, { id_price_table });
    return response.data;
  }

  async function convert(id) {
    const response = await http.post('/orders/convert/'+id, {});
    return response.data;
  }

  async function delet(id) {
    await http.put('/orders/delete/'+id, {});
    return true;
  }

  return {list, getOne, update, updateStatus, applyPriceTable, convert, delet};
}
